// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__GiVo4","topBottomGutter":"Layout_topBottomGutter__2o9FO"};